import React from 'react';
import styled from 'styled-components';
import Typography from '@material-ui/core/Typography/Typography';
import { FormattedMessage } from 'react-intl';
import { Grid } from '@material-ui/core';
import { colors } from 'styles';
import { Container } from 'components/basics';
import { breakpoint } from 'src/utils/mediaQueries';
import BlockImages from 'components/pages/Qemotion/IntroBlock/BlockImages/BlockImages';

const StyledContainer = styled(Container)`
  width: 100%;
  padding-bottom: 4rem;
`;
const BlockIntro = styled(Grid)`
  width: 100%;
`;
const BlockImageGrid = styled(Grid)`
  padding-top: 4rem;
  width: 100%;
  ${breakpoint.down('md')`
  justify-content: flex-end; padding-top: 2rem`}
`;
const StyledTypography = styled(Typography)`
  text-align: center;
  line-height: 2rem;

  span {
    color: ${colors.purple};
  }
  ${breakpoint.down('sm')`    
  font-size: ${props => `${props.theme.typography.body1.fontSize}px`};`}
  ${breakpoint.only('xxs')`
    font-size: ${props => `${props.theme.typography.subtitle2.fontSize}px`};`}
`;
const StyledGrid = styled(Grid)`
  flex: 0 0 auto;
`;

const MainTitle = styled(StyledTypography)`
  margin-bottom: 0.5em;
  line-height: 3rem;
`;

const IntroBlocks = ({ data }) => {
  return (
    <StyledContainer>
      <BlockIntro
        container
        alignItems="center"
        spacing={40}
        justify="center"
        direction={'column'}
        wrap={'nowrap'}
      >
        <StyledGrid
          container
          justify={'center'}
          item
          xs={12}
          sm={12}
          md={8}
          lg={7}
        >
          <MainTitle variant="h1">
            <FormattedMessage id="qemotionPage.main_title" />
          </MainTitle>
          <StyledTypography
            variant="h5"
            dangerouslySetInnerHTML={{ __html: data.title.rawMarkdownBody }}
          />
        </StyledGrid>
        <BlockImageGrid container spacing={40}>
          {data.markdownContent.map((block, index) => {
            return (
              <BlockImages
                order={block.frontmatter.order === 0 ? 'even' : 'odd'}
                data={block}
                images={data.images}
                key={`BlockImages${index}`}
              />
            );
          })}
        </BlockImageGrid>
      </BlockIntro>
    </StyledContainer>
  );
};

export default IntroBlocks;
